import React, { FC, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import history from './app.history';

import Home from './Pages/Home/Home';
import Dashboard from './Pages/Dashboard/Dashboard';
import Admin from './Pages/Admin/Admin';
import NotFound from './Components/NotFound/NotFound';

import './App.css';

const App: FC<{ patronid: string; email: string; firstName: string; lastName: string }> = ({
    patronid,
    email,
    firstName,
    lastName,
}): JSX.Element => {
    useEffect(() => {
        document.title = 'CatiClick';
    }, []);

    return (
        <Router >
            <Routes>
                <Route path="/caticlick" element={<Home />} />
                <Route

                    path="/caticlick/dashboard"
                    element={<Dashboard student={{ patronid, email, firstName, lastName }} />}
                />
                <Route

                    path="/caticlick/admin"
                    element={
                        ['lsevanto', 'ahernandez-perez2', 'jgermino', 'rbellofatto', 'rbraden', 'erahilly', 'dgallegosgutierrez', 'jbair2', 'elandaverry', 'cvalentine2', 'awu92', 'aschweickert', 'brusson', 'dlo6', 'echang52', 'jamesqian', 'jvaleriano2', 'jsalgado19', 'mcavoy-jensen', 'mmubako', 'nbaba', 'jbarrera41'].includes(
                            email.split("@")[0],
                        ) ? (
                            <Admin email={email} />
                        ) : (
                            <NotFound />
                        )
                    }
                />
            </Routes>
        </Router>
    );
};

export default App;
